import React from 'react'

export const SwipeDownIcon = ({ height = 30, color = 'black', style }) => (
  <svg x="0px" y="0px" viewBox="0 0 58.1 90" height={height} {...style}>
    <g fill={color}>
      <polygon points="56.4,17 54.2,19.2 54.2,0 51.7,0 51.7,19.2 49.5,17 47.7,18.7 52.9,23.9 58.1,18.7 	" />
      <path
        d="M46.9,43.9c-1.3-1.1-3.1-1.4-5.4-1.1c-0.2-3.1-1.3-6.1-5.5-6.5c-1.4-0.1-2.5,0-3.3,0.2l-1-24.2c-0.2-4.9-2.7-7.5-7-7.3
		c-4.1,0.2-6.3,2.7-6.3,7.1c-1.2-1.2-2.9-1.8-5.1-1.7c-4.3,0.3-6.5,3.1-6.2,8l1.2,26.4c-0.5,0-1-0.1-1.4-0.1c-2.5,0-5.5,1.3-6.1,6.9
		c0,0.2-0.5,4-0.6,9.1c-0.1,7,1.2,12.9,3.8,16.9c4.7,7.3,11,10,11.7,10.2c0.5,0.3,4.4,2,11.1,2c7.1,0,11.7-2.4,12.3-2.7
		C39.7,86.8,50,81.5,50,63.8c0-5.7-0.1-8.3-0.4-13.2C49.4,47.3,48.6,45.2,46.9,43.9z M37.7,85.1L37.7,85.1
		c-0.1,0.1-4.5,2.5-11.2,2.5c-6.4,0-10-1.7-10-1.7l-0.1-0.1c-0.1,0-6.1-2.4-10.5-9.3c-2.3-3.6-3.5-9.1-3.4-15.6
		c0.1-5,0.6-8.8,0.6-8.9c0.5-4.2,2.2-4.7,3.7-4.8c0.5,0,1,0,1.5,0.1L9,64l2.5-0.1l-2-45.6c-0.3-4.5,1.9-5.3,3.9-5.4
		c2-0.1,4.3,0.3,4.5,4.9L20,52.7h0l0,0.9l2.5-0.1l-1.7-40.7c-0.2-4.5,2-5.2,4-5.3c2-0.1,4.3,0.4,4.5,4.9l1.6,37l2.5-0.1L32.8,39
		c0.6-0.2,1.5-0.5,3-0.3c2.1,0.2,3.3,1.2,3.3,5.8v10h2.5v-9.3c1.7-0.3,3-0.1,3.8,0.6c1,0.8,1.6,2.4,1.7,5c0.3,4.4,0.4,7,0.4,13
		C47.5,80.2,38.1,84.9,37.7,85.1z"
      />
    </g>
  </svg>
)

export const DragIcon = ({ height = 30, color = 'black', style }) => (
  <svg x="0px" y="0px" viewBox="0 0 56 90" height={height} {...style}>
    <g fill={color}>
      <path
        d="M46.1,44.7c-1.3-1-3.1-1.4-5.3-1.1c-0.2-3-1.3-6-5.4-6.4c-1.9-0.2-3.3,0.2-4.1,0.5c-1.1-3.4-3.5-4.2-5.7-4.2
		c-1.7,0-3,0.2-3.9,0.4V19.3c0-4.8-2.3-7.5-6.6-7.5c-4.2,0-6.6,2.6-6.6,7.5v26.4c-0.6-0.1-1.3-0.1-1.9-0.1c-2.4,0-5.4,1.2-6,6.8
		c0,0.2-0.5,4-0.6,9C-0.1,68.3,1.2,74,3.7,78c4.6,7.2,10.8,9.8,11.4,10.1C15.7,88.3,19.5,90,26,90c6.9,0,11.5-2.4,12-2.7
		c0.9-0.4,11-5.7,11-23c0-5.7-0.1-8.2-0.4-12.9C48.5,48.1,47.7,46,46.1,44.7z M37,85.1L37,85.1c-0.1,0.1-4.4,2.4-11,2.4
		c-6.3,0-9.8-1.7-9.8-1.7h-0.1c-0.1,0-6-2.4-10.3-9.1c-2.3-3.5-3.4-8.9-3.3-15.3c0-4.8,0.5-8.6,0.5-8.7c0.4-4.1,2.2-4.6,3.7-4.7
		c0.6,0,1.3,0,1.9,0.1v13.7H11V19.3c0-4.5,2.2-5,4.2-5c1.9,0,4.2,0.6,4.2,5v27.4h2.4V36.5c0.7-0.2,2-0.5,3.9-0.5
		c1.1,0,3.9,0,3.9,6.4v9.4H32v-9.4c0-0.8,0-1.5-0.1-2.1c0.3-0.2,1.4-0.8,3.4-0.6s3.3,1.2,3.3,5.7v9.9H41V46c1.7-0.3,2.9-0.1,3.7,0.6
		c1,0.8,1.6,2.4,1.7,4.9c0.3,4.7,0.4,7.2,0.4,12.8C46.7,80.4,37.4,85,37,85.1z"
      />
      <polygon
        points="51,7.9 49.3,9.6 51.4,11.8 44.3,11.8 44.3,4.6 46.4,6.8 48.1,5.1 43,0 38,5.1 39.7,6.8 41.8,4.6 41.8,11.8 
		34.7,11.8 36.8,9.6 35.1,7.9 30.1,13 35.1,18 36.8,16.3 34.7,14.2 41.8,14.2 41.8,21.3 39.7,19.2 38,20.9 43,26 48.1,20.9 
		46.4,19.2 44.3,21.3 44.3,14.2 51.4,14.2 49.3,16.3 51,18 56,13 	"
      />
    </g>
  </svg>
)

export const PayPal = ({ height }) => (
  <svg
    version="1.1"
    id="Layer_1"
    x="0px"
    y="0px"
    viewBox="0 0 780 501"
    height={height}
  >
    <g>
      <path
        fill="#393939"
        d="M168.4,169.9c-8.4-5.8-19.4-8.7-32.9-8.7H83.2c-4.1,0-6.4,2.1-6.9,6.2L55,300.9c-0.2,1.3,0.1,2.5,1,3.6
			s2,1.6,3.3,1.6h24.9c4.4,0,6.8-2.1,7.2-6.2l5.9-36c0.2-1.7,1-3.2,2.3-4.3c1.3-1.1,2.9-1.8,4.9-2.1c2-0.3,3.8-0.5,5.6-0.5
			c1.7,0,3.8,0.1,6.2,0.3c2.4,0.2,3.9,0.3,4.6,0.3c18.8,0,33.5-5.3,44.2-15.9c10.7-10.6,16-25.2,16-44
			C181,185,176.8,175.6,168.4,169.9z M141.4,209.9c-1.1,7.6-3.9,12.6-8.5,15s-11.1,3.6-19.6,3.6l-10.8,0.3l5.6-35
			c0.4-2.4,1.9-3.6,4.3-3.6h6.2c8.7,0,15,1.3,19,3.8C141.4,196.6,142.7,201.9,141.4,209.9z"
      />
      <path
        fill="#393939"
        d="M720.8,161.2h-24.2c-2.4,0-3.8,1.2-4.3,3.6L671,300.9l-0.3,0.7c0,1.1,0.4,2.1,1.3,3.1c0.9,1,2,1.5,3.3,1.5
			h21.6c4.1,0,6.4-2.1,6.9-6.2L725,166.1v-0.3C725,162.7,723.6,161.2,720.8,161.2z"
      />
      <path
        fill="#393939"
        d="M428.3,213.9c0-1.1-0.4-2.1-1.3-3.1s-1.9-1.5-2.9-1.5h-25.2c-2.4,0-4.4,1.1-5.9,3.3l-34.7,51l-14.4-49.1
			c-1.1-3.5-3.5-5.2-7.2-5.2h-24.5c-1.1,0-2.1,0.5-2.9,1.5c-0.9,1-1.3,2-1.3,3.1c0,0.4,2.1,6.9,6.4,19.3c4.3,12.4,8.8,25.8,13.7,40.2
			c4.9,14.4,7.5,22,7.7,22.9c-17.9,24.4-26.8,37.5-26.8,39.3c0,2.8,1.4,4.3,4.3,4.3h25.2c2.4,0,4.4-1.1,5.9-3.3l83.4-120.4
			C428.1,215.7,428.3,215,428.3,213.9z"
      />
      <path
        fill="#393939"
        d="M662.9,209.3H638c-3.1,0-4.9,3.6-5.6,10.8c-5.7-8.7-16-13.1-31.1-13.1c-15.7,0-29.1,5.9-40.1,17.7
			s-16.5,25.6-16.5,41.6c0,12.9,3.8,23.1,11.3,30.8c7.5,7.6,17.6,11.5,30.3,11.5c6.3,0,12.8-1.3,19.3-3.9s11.7-6.1,15.4-10.5
			c0,0.2-0.2,1.2-0.7,2.9c-0.4,1.7-0.7,3.1-0.7,3.9c0,3.5,1.4,5.2,4.3,5.2h22.6c4.1,0,6.5-2.1,7.2-6.2l13.4-85.4
			c0.2-1.3-0.1-2.5-1-3.6C665.3,209.8,664.2,209.3,662.9,209.3z M620.2,273.7c-5.6,5.5-12.3,8.2-20.1,8.2c-6.3,0-11.4-1.7-15.4-5.2
			c-3.9-3.5-5.9-8.3-5.9-14.4c0-8.1,2.7-14.9,8.2-20.4c5.4-5.6,12.2-8.3,20.3-8.3c6.1,0,11.2,1.8,15.2,5.4c4,3.6,6.1,8.6,6.1,14.9
			C628.5,261.6,625.8,268.3,620.2,273.7z"
      />
      <path
        fill="#393939"
        d="M291.2,209.3h-24.9c-3.1,0-4.9,3.6-5.6,10.8c-5.9-8.7-16.2-13.1-31.1-13.1c-15.7,0-29.1,5.9-40.1,17.7
			S173,250.3,173,266.3c0,12.9,3.8,23.1,11.3,30.8c7.5,7.6,17.6,11.5,30.3,11.5c6.1,0,12.4-1.3,19-3.9c6.5-2.6,11.8-6.1,15.7-10.5
			c-0.9,2.6-1.3,4.9-1.3,6.9c0,3.5,1.4,5.2,4.3,5.2h22.6c4.1,0,6.5-2.1,7.2-6.2l13.4-85.4c0.2-1.3-0.1-2.5-1-3.6
			C293.6,209.8,292.5,209.3,291.2,209.3z M248.5,273.9c-5.6,5.4-12.4,8-20.4,8c-6.3,0-11.4-1.7-15.2-5.2s-5.7-8.3-5.7-14.4
			c0-8.1,2.7-14.9,8.2-20.4c5.4-5.6,12.2-8.3,20.3-8.3c6.1,0,11.2,1.8,15.2,5.4c4,3.6,6.1,8.6,6.1,14.9
			C256.9,261.8,254.1,268.6,248.5,273.9z"
      />
      <path
        fill="#393939"
        d="M540,169.9c-8.4-5.8-19.4-8.7-32.9-8.7h-52c-4.4,0-6.8,2.1-7.2,6.2l-21.3,133.5c-0.2,1.3,0.1,2.5,1,3.6
			s2,1.6,3.3,1.6h26.8c2.6,0,4.4-1.4,5.2-4.3l5.9-37.9c0.2-1.7,1-3.2,2.3-4.3c1.3-1.1,2.9-1.8,4.9-2.1c2-0.3,3.8-0.5,5.6-0.5
			c1.7,0,3.8,0.1,6.2,0.3c2.4,0.2,3.9,0.3,4.6,0.3c18.8,0,33.5-5.3,44.2-15.9c10.7-10.6,16-25.2,16-44
			C552.6,185,548.4,175.6,540,169.9z M506.5,223.7c-4.8,3.3-12,4.9-21.6,4.9l-10.5,0.3l5.6-35c0.4-2.4,1.8-3.6,4.3-3.6h5.9
			c4.8,0,8.6,0.2,11.5,0.7c2.8,0.4,5.6,1.8,8.2,4.1s3.9,5.6,3.9,10C513.7,214.2,511.3,220.4,506.5,223.7z"
      />
    </g>
  </svg>
)

export const Amex = ({ height }) => (
  <svg version="1.1" height={height} x="0px" y="0px" viewBox="0 0 750 471">
    <g>
      <path
        fill="#393939"
        d="M554.6,130.6l-14.5,35h29.1L554.6,130.6z M387,152.3c2.7-1.4,4.3-4.5,4.3-8.4c0-3.8-1.7-6.5-4.4-7.8
				c-2.5-1.4-6.3-1.6-10-1.6h-26v19.5h25.6C380.7,154.1,384.1,154.1,387,152.3z M54.1,130.6l-14.4,35h28.8L54.1,130.6z M722.6,355.1
				h-40.7v-18.9h40.6c4,0,6.8-0.5,8.5-2.2c1.5-1.4,2.5-3.3,2.5-5.7c0-2.6-1-4.6-2.6-5.8c-1.5-1.3-3.8-2-7.4-2
				c-19.8-0.7-44.5,0.6-44.5-27.2c0-12.8,8.1-26.2,30.3-26.2h42v-17.5h-39c-11.8,0-20.3,2.8-26.4,7.2v-7.2H628
				c-9.2,0-20.1,2.3-25.2,7.2v-7.2H499.7v7.2c-8.2-5.9-22.1-7.2-28.4-7.2h-68v7.2c-6.5-6.3-20.9-7.2-29.7-7.2h-76.1l-17.4,18.8
				l-16.3-18.8H149.8v122.7h111.6l18-19.1l16.9,19.1l68.8,0.1v-28.9h6.8c9.1,0.1,19.9-0.2,29.4-4.3v33.1H458v-32h2.7
				c3.5,0,3.8,0.1,3.8,3.6v28.3h172.3c10.9,0,22.4-2.8,28.7-7.9v7.9h54.7c11.4,0,22.5-1.6,30.9-5.7v-22.9
				C746.1,351.3,736.1,355.1,722.6,355.1z M372.7,326.1h-26.3v29.5h-41l-26-29.1l-27,29.1h-83.6v-87.9h84.9l26,28.8l26.8-28.8h67.4
				c16.7,0,35.6,4.6,35.6,29C409.5,321.1,391.2,326.1,372.7,326.1z M499.3,322.1c3,4.3,3.4,8.3,3.5,16v17.4h-21.2v-11
				c0-5.3,0.5-13.1-3.4-17.2c-3.1-3.1-7.8-3.9-15.5-3.9h-22.5v32.1H419v-87.9h48.7c10.7,0,18.5,0.5,25.4,4.1c6.7,4,10.8,9.5,10.8,19.5
				c0,14-9.4,21.2-15,23.4C493.7,316.5,497.5,319.6,499.3,322.1z M586.5,285.9h-49.4v16h48.2v17.9h-48.2v17.5l49.4,0.1v18.2h-70.4
				v-87.9h70.4V285.9z M640.7,355.6h-41.1v-18.9h40.9c4,0,6.8-0.5,8.6-2.2c1.4-1.4,2.5-3.3,2.5-5.7c0-2.6-1.1-4.6-2.6-5.8
				c-1.6-1.3-3.8-1.9-7.5-1.9c-19.7-0.7-44.4,0.6-44.4-27.2c0-12.8,8-26.2,30.2-26.2h42.3v18.7h-38.7c-3.8,0-6.3,0.1-8.5,1.6
				c-2.3,1.4-3.2,3.5-3.2,6.3c0,3.3,2,5.6,4.6,6.5c2.2,0.8,4.6,1,8.2,1l11.4,0.3c11.4,0.3,19.3,2.2,24.1,7.1c4.1,4.2,6.3,9.6,6.3,18.6
				C673.8,346.8,662,355.6,640.7,355.6z M751.2,343.8L751.2,343.8L751.2,343.8L751.2,343.8z M477.1,287.3c-2.5-1.5-6.3-1.6-10.1-1.6
				h-26v19.7h25.6c4.1,0,7.6-0.1,10.4-1.8c2.7-1.6,4.4-4.7,4.4-8.4C481.4,291.4,479.8,288.7,477.1,287.3z M712.8,285.7
				c-3.8,0-6.4,0.1-8.5,1.6c-2.2,1.4-3.1,3.5-3.1,6.3c0,3.3,1.9,5.6,4.6,6.5c2.2,0.8,4.6,1,8.1,1l11.4,0.3c11.5,0.3,19.2,2.3,23.9,7.1
				c0.9,0.7,1.4,1.4,2,2.2v-25L712.8,285.7L712.8,285.7L712.8,285.7z M373.5,285.7H346v22.4h27.3c8.1,0,13.1-4,13.1-11.6
				C386.4,288.8,381.1,285.7,373.5,285.7z M189.9,285.7v16h46.3v17.9h-46.3v17.5h51.9l24.1-25.8l-23.1-25.6H189.9L189.9,285.7z
				M325.3,347.2v-70.5l-32.4,34.7L325.3,347.2z M191.6,206v15.1h176.3l-0.1-32h3.4c2.4,0.1,3.1,0.3,3.1,4.2v27.8h91.2v-7.5
				c7.4,3.9,18.8,7.5,33.8,7.5h38.4l8.2-19.5h18.2l8,19.5H646v-18.5l11.2,18.5h59.2V98.6h-58.6v14.5l-8.2-14.5h-60.1v14.5l-7.5-14.5
				h-81.2c-13.6,0-25.6,1.9-35.2,7.2v-7.2h-56.1v7.2c-6.1-5.4-14.5-7.2-23.8-7.2H180.8L167,130.3l-14.1-31.7H88.4v14.5l-7.1-14.5h-55
				L0.8,156.9v46.6l37.8-87.9h31.3l35.9,83.2v-83.2h34.4l27.6,59.6l25.4-59.6h35.1v87.9h-21.6l-0.1-68.8L176,203.5h-18.5l-30.7-68.9
				v68.9H83.9l-8.1-19.6H31.9l-8.2,19.6H0.8v17.7h36l8.1-19.5h18.2l8.1,19.5h70.9v-14.9l6.3,15h36.8L191.6,206z M469.4,125.8
				c6.8-7,17.5-10.2,32-10.2h20.4v18.8h-20c-7.7,0-12,1.1-16.2,5.2c-3.6,3.7-6.1,10.7-6.1,19.9c0,9.4,1.9,16.2,5.8,20.6
				c3.2,3.5,9.2,4.5,14.7,4.5h9.5l29.7-69.1h31.6l35.7,83.1v-83.1h32.1l37.1,61.2v-61.2h21.6v87.9h-29.9l-40-66v66h-43l-8.2-19.6
				h-43.8l-8,19.6h-24.7c-10.3,0-23.2-2.3-30.6-9.7c-7.4-7.5-11.3-17.6-11.3-33.6C458,147.2,460.3,135.3,469.4,125.8z M426,115.6h21.5
				v87.9H426V115.6z M329,115.6h48.5c10.8,0,18.7,0.3,25.5,4.2c6.7,3.9,10.7,9.7,10.7,19.5c0,14-9.4,21.3-14.9,23.4
				c4.6,1.8,8.6,4.8,10.4,7.4c3,4.4,3.5,8.3,3.5,16.1v17.3h-21.3l-0.1-11.1c0-5.3,0.5-12.9-3.3-17.1c-3.1-3.1-7.8-3.8-15.4-3.8H350v32
				H329L329,115.6L329,115.6z M243.9,115.6h70.5v18.3H265v15.8h48.2v18H265v17.6h49.4v18.2h-70.5L243.9,115.6L243.9,115.6z"
      />
    </g>
  </svg>
)

export const Maestro = ({ height }) => (
  <svg version="1.1" x="0px" y="0px" viewBox="0 0 750 471" height={height}>
    <g id="Group" transform="translate(154.000000, 60.000000)">
      <path
        fill="#393939"
        d="M132.8,349v-23.2c0-8.8-5.6-14.6-14.6-14.7c-4.7-0.1-9.6,1.4-13,6.6c-2.6-4.1-6.6-6.6-12.2-6.6
				c-4.3-0.2-8.5,1.8-10.9,5.5v-4.6h-8.1v37h8.1v-20.5c0-6.4,3.6-9.8,9.1-9.8c5.3,0,8.1,3.5,8.1,9.8V349h8.1v-20.5
				c0-6.4,3.7-9.8,9.1-9.8c5.5,0,8.1,3.5,8.1,9.8V349L132.8,349z M178.2,330.5V312h-8.1v4.5c-2.6-3.3-6.4-5.4-11.7-5.4
				c-10.4,0-18.5,8.1-18.5,19.4s8.1,19.4,18.5,19.4c5.3,0,9.1-2.1,11.7-5.4v4.5h8.1V330.5z M148.2,330.5c0-6.5,4.3-11.9,11.2-11.9
				c6.7,0,11.2,5.1,11.2,11.9c0,6.7-4.5,11.9-11.2,11.9C152.5,342.4,148.2,337,148.2,330.5L148.2,330.5z M350.6,311
				c2.7,0,5.4,0.5,8,1.5c2.4,0.9,4.5,2.3,6.3,4.1c1.8,1.8,3.2,3.9,4.2,6.2c2,5,2,10.5,0,15.5c-1,2.3-2.4,4.4-4.2,6.2
				c-1.8,1.8-4,3.2-6.3,4.1c-5.1,2-10.8,2-15.9,0c-2.4-0.9-4.5-2.3-6.3-4.1c-1.8-1.8-3.2-3.9-4.2-6.2c-2-5-2-10.5,0-15.5
				c1-2.3,2.4-4.4,4.2-6.2c1.8-1.8,4-3.2,6.3-4.1C345.2,311.5,347.9,311,350.6,311z M350.6,318.6c-1.6,0-3.1,0.3-4.6,0.9
				c-1.4,0.6-2.6,1.4-3.7,2.4c-1.1,1.1-1.9,2.3-2.4,3.7c-1.2,3.1-1.2,6.5,0,9.6c0.6,1.4,1.4,2.7,2.4,3.7c1,1.1,2.3,1.9,3.7,2.4
				c3,1.2,6.2,1.2,9.2,0c1.4-0.6,2.6-1.4,3.7-2.4c1.1-1.1,1.9-2.3,2.5-3.7c1.2-3.1,1.2-6.5,0-9.6c-0.6-1.4-1.4-2.7-2.5-3.7
				c-1.1-1.1-2.3-1.9-3.7-2.4C353.7,318.9,352.2,318.6,350.6,318.6z M222,330.5c-0.1-11.5-7.2-19.4-17.6-19.4
				c-10.8,0-18.4,7.9-18.4,19.4c0,11.8,7.9,19.4,19,19.4c5.6,0,10.7-1.4,15.2-5.2l-4-6c-3.1,2.5-6.8,3.8-10.8,3.9
				c-5.2,0-9.9-2.4-11.1-9.1h27.5C221.9,332.6,222,331.6,222,330.5z M194.5,327.3c0.9-5.3,4.1-9,9.8-9c5.2,0,8.5,3.2,9.4,9H194.5z
				M256,321.5c-3.5-2-7.5-3.1-11.6-3.2c-4.4,0-7.1,1.6-7.1,4.3c0,2.5,2.8,3.2,6.3,3.6l3.8,0.5c8.1,1.2,12.9,4.6,12.9,11.1
				c0,7.1-6.2,12.1-16.9,12.1c-6,0-11.6-1.6-16-4.8l3.8-6.3c3.6,2.6,7.9,4,12.3,3.9c5.5,0,8.4-1.6,8.4-4.5c0-2.1-2.1-3.2-6.5-3.9
				l-3.8-0.5c-8.3-1.2-12.8-4.9-12.8-10.9c0-7.4,6-11.9,15.4-11.9c5.9,0,11.2,1.3,15.1,3.9L256,321.5z M294.7,319.3h-13.2v16.8
				c0,3.7,1.3,6.2,5.3,6.2c2.5-0.1,5-0.8,7.1-2.1l2.3,6.9c-3,1.9-6.5,2.9-10.1,2.9c-9.5,0-12.9-5.1-12.9-13.7v-16.9h-7.5V312h7.5
				v-11.2h8.1V312h13.2L294.7,319.3z M322.6,311c2,0,3.9,0.4,5.7,1l-2.5,7.6c-1.6-0.6-3.3-1-5-0.9c-5.3,0-7.9,3.4-7.9,9.5V349h-8.1
				v-37h7.9v4.5C314.8,313.1,318.5,311,322.6,311L322.6,311z"
      />
      <path
        fill="#393939"
        d="M400.6,41.3C352.4-6.9,276.5-13.2,221,26.4C178.5-3.9,122.5-7.9,76.1,16S0.5,87.8,0.5,140.1
				c0,52.2,29.2,100.1,75.6,124.1s102.4,19.9,144.9-10.4c42.5,30.3,98.5,34.3,144.9,10.4s75.6-71.8,75.6-124.1
				C441.6,103,426.9,67.5,400.6,41.3z M221,231.7c-26.2-23.2-41.2-56.6-41.2-91.6s15-68.3,41.2-91.6c26.2,23.2,41.2,56.6,41.2,91.6
				S247.2,208.5,221,231.7z M140.1,262.2c-67.4,0-122.1-54.7-122.1-122.1S72.7,18.1,140.1,18.1c23.6-0.1,46.8,6.8,66.5,19.8
				c-28.3,26.5-44.4,63.5-44.4,102.2s16.1,75.8,44.4,102.2C186.9,255.4,163.8,262.3,140.1,262.2z M301.9,262.2
				c-23.6,0.1-46.7-6.8-66.5-19.8c28.3-26.5,44.4-63.5,44.4-102.3s-16.1-75.8-44.4-102.3c19.8-13,42.9-19.9,66.5-19.8
				c67.4,0,122.1,54.7,122.1,122.1S369.3,262.2,301.9,262.2L301.9,262.2z"
      />
    </g>
  </svg>
)

export const Mastercard = ({ height }) => (
  <svg version="1.1" x="0px" y="0px" viewBox="0 0 750 471" height={height}>
    <g id="Group" transform="translate(159.000000, 64.000000)">
      <path
        fill="#393939"
        d="M74.3,342v-22.7c0-8.7-5.3-14.4-14-14.4c-4.6,0-9.5,1.5-12.9,6.4c-2.7-4.2-6.4-6.4-12.1-6.4
				c-4.3-0.2-8.4,1.8-11,5.3v-4.6H17V342h7.2v-20.8c0-6.4,3.8-9.5,9.1-9.5s8.3,3.4,8.3,9.5V342h7.2v-20.8c0-6.4,3.8-9.5,9.1-9.5
				s8.3,3.4,8.3,9.5V342H74.3z M192.5,306h-13.3v-11h-7.2v11h-7.6v6.4h7.6v17.1c0,8.3,3,13.3,12.1,13.3c3.4-0.1,6.8-1,9.8-2.7
				l-2.3-6.4c-2,1.3-4.4,1.9-6.8,1.9c-3.8,0-5.7-2.3-5.7-6.1v-17.4h13.3L192.5,306L192.5,306z M260,304.9c-4-0.1-7.7,1.9-9.9,5.3v-4.6
				h-7.2V342h7.2v-20.4c0-6.1,3-9.9,8-9.9c1.7,0.1,3.3,0.3,4.9,0.8l2.3-6.8C263.6,305.2,261.8,304.9,260,304.9z M158,308.6
				c-3.8-2.7-9.1-3.8-14.8-3.8c-9.1,0-14.8,4.2-14.8,11.4c0,6.1,4.2,9.5,12.1,10.6l3.8,0.4c4.2,0.8,6.8,2.3,6.8,4.2
				c0,2.7-3,4.6-8.7,4.6c-4.3,0.1-8.6-1.2-12.1-3.8l-3.8,5.7c5.3,3.8,11.8,4.6,15.6,4.6c10.6,0,16.3-4.9,16.3-11.8
				c0-6.4-4.6-9.5-12.5-10.6l-3.8-0.4c-3.4-0.4-6.4-1.5-6.4-3.8c0-2.7,3-4.6,7.2-4.6c4.6,0,9.1,1.9,11.4,3L158,308.6z M268,323.8
				c0,11,7.2,19,19,19c5.3,0,9.1-1.1,12.9-4.2l-3.8-5.7c-2.7,2.2-6,3.4-9.5,3.4c-6.4,0-11.4-4.9-11.4-12.1c0-7.2,4.9-12.1,11.4-12.1
				c3.5,0,6.8,1.2,9.5,3.4l3.8-5.7c-3.8-3-7.6-4.2-12.9-4.2C275.5,304.9,268,312.9,268,323.8L268,323.8z M217.2,304.9
				c-10.6,0-17.8,7.6-17.8,19s7.6,19,18.6,19c5.3,0.1,10.6-1.6,14.8-4.9l-3.8-5.3c-3,2.4-6.8,3.7-10.6,3.8c-4.9,0-10.2-3-11-9.5h26.9
				v-3C234.2,312.4,227.4,304.9,217.2,304.9L217.2,304.9z M216.8,311.7c5.3,0,9.1,3.4,9.5,9.1h-19.7
				C207.7,315.5,211.1,311.7,216.8,311.7z M118.6,323.8v-18.2h-7.2v4.6c-2.7-3.4-6.4-5.3-11.8-5.3c-10.2,0-17.8,8-17.8,19
				c0,11,7.6,19,17.8,19c5.3,0,9.1-1.9,11.8-5.3v4.6h7.2V323.8z M89.4,323.8c0-6.8,4.2-12.1,11.4-12.1c6.8,0,11,5.3,11,12.1
				c0,7.2-4.6,12.1-11,12.1C93.6,336.3,89.4,330.6,89.4,323.8z M369.6,304.9c-4-0.1-7.7,1.9-9.9,5.3v-4.6h-7.2V342h7.2v-20.4
				c0-6.1,3-9.9,8-9.9c1.7,0.1,3.3,0.3,4.9,0.8l2.3-6.8C373.1,305.2,371.3,304.9,369.6,304.9L369.6,304.9z M341.5,323.8v-18.2h-7.2
				v4.6c-2.7-3.4-6.4-5.3-11.8-5.3c-10.2,0-17.8,8-17.8,19c0,11,7.6,19,17.8,19c5.3,0,9.1-1.9,11.8-5.3v4.6h7.2V323.8z M312.3,323.8
				c0-6.8,4.2-12.1,11.4-12.1c6.8,0,11,5.3,11,12.1c0,7.2-4.6,12.1-11,12.1C316.5,336.3,312.3,330.6,312.3,323.8z M414.7,323.8v-32.6
				h-7.2v19c-2.7-3.4-6.4-5.3-11.8-5.3c-10.2,0-17.8,8-17.8,19c0,11,7.6,19,17.8,19c5.3,0,9.1-1.9,11.8-5.3v4.6h7.2V323.8z
				M385.5,323.8c0-6.8,4.2-12.1,11.4-12.1c6.8,0,11,5.3,11,12.1c0,7.2-4.6,12.1-11,12.1C389.7,336.3,385.5,330.6,385.5,323.8
				L385.5,323.8z"
      />
      <path
        fill="#393939"
        d="M391.6,40.4C344.5-6.7,270.2-12.9,216,25.8C174.4-3.8,119.8-7.7,74.4,15.7S0.5,85.9,0.5,136.9
				c0,51.1,28.5,97.9,73.9,121.3s100,19.5,141.6-10.1c41.6,29.6,96.2,33.5,141.6,10.1s73.9-70.2,73.9-121.3
				C431.6,100.7,417.2,66,391.6,40.4z M216,226.4c-25.6-22.7-40.3-55.3-40.3-89.5s14.7-66.8,40.3-89.5c25.6,22.7,40.3,55.3,40.3,89.5
				S241.6,203.7,216,226.4z M137,256.3c-65.9,0-119.3-53.4-119.3-119.3S71.1,17.6,137,17.6c23.1-0.1,45.7,6.7,65,19.4
				c-27.7,25.9-43.4,62-43.4,99.9s15.7,74.1,43.4,99.9C182.7,249.6,160.1,256.3,137,256.3z M295,256.3c-23.1,0.1-45.7-6.7-65-19.3
				c27.7-25.9,43.4-62.1,43.4-99.9S257.7,62.9,230.1,37c19.3-12.7,41.9-19.5,65-19.4c65.9,0,119.3,53.4,119.3,119.3
				S361,256.3,295,256.3L295,256.3z"
      />
    </g>
  </svg>
)

export const ApplePay = ({ height }) => (
  <svg version="1.1" x="0px" y="0px" viewBox="0 0 2500 1601" height={height}>
    <path
      fill="#393939"
      d="M1977.1,233.2H489.8c-10.7,0-22.5,1-33.1,3.2s-21.4,5.4-32.1,10.7c-9.6,4.2-19.3,11.8-26.7,19.3
      c-7.5,7.5-15,17.1-19.3,26.7c-5.4,9.6-8.6,20.3-10.7,32.1c-2.2,10.7-2.2,22.5-3.2,33.1v882.8c0,10.7,1,22.5,3.2,33.1
      c2.2,10.7,5.4,21.4,10.7,32.1c5.4,9.6,11.8,19.3,19.3,26.7c7.5,7.4,17.1,15,26.7,19.3c9.6,5.4,20.3,8.6,32.1,10.7
      c10.7,2.2,22.5,2.2,33.1,3.2h1520.6c10.7,0,22.5-1,33.1-3.2c10.7-2.2,21.4-5.4,32.1-10.7c9.6-5.4,19.3-11.8,26.7-19.3
      c7.5-7.5,15-17.1,19.3-26.7c5.4-9.6,8.6-20.3,10.7-32.1c2.2-10.7,2.2-22.5,3.2-33.1v-15V391.5v-18.2v-15c0-10.7-1-22.5-3.2-33.1
      c-2.2-10.7-5.4-21.4-10.7-32.1c-5.4-9.6-11.8-19.3-19.3-26.7c-7.5-7.5-17.1-15-26.7-19.3c-9.6-5.4-20.3-8.6-32.1-10.7
      c-10.7-2.2-22.5-2.2-33.1-3.2L1977.1,233.2L1977.1,233.2z"
    />
    <path
      fill="#fff"
      d="M1977.1,270.6h33.1c8.6,0,18.2,1,27.9,2.2c8.6,1,15,3.2,21.4,6.4c6.4,3.2,11.8,7.5,17.1,12.8
      c5.4,5.4,9.6,10.7,12.8,17.1c3.2,6.4,5.4,12.8,6.4,21.4c2.2,9.6,2.2,19.3,2.2,27.9v882.8c0,8.6-1,18.2-2.2,27.9
      c-1,7.5-3.2,15-6.4,21.4c-3.2,6.4-7.5,11.8-12.8,17.1c-5.4,5.4-10.7,9.6-17.1,12.8c-6.4,3.2-12.8,5.4-21.4,6.4
      c-9.6,2.2-19.3,2.2-27.9,2.2H489.8c-7.5,0-18.2-1-27.9-2.2c-7.5-1-15-3.2-21.4-7.5c-6.4-3.2-11.8-7.5-17.1-12.8
      c-5.4-5.4-9.6-10.7-12.8-17.1c-3.2-6.4-5.4-12.8-6.4-21.4c-2.2-9.6-2.2-19.3-2.2-27.9V373.4v-15c0-8.6,1-18.2,2.2-27.9
      c1-7.5,3.2-15,6.4-21.4c3.2-6.4,7.5-11.8,12.8-17.1c5.4-5.4,10.7-9.6,17.1-12.8c6.4-3.2,12.8-5.4,21.4-6.4
      c9.6-2.2,19.3-2.2,27.9-2.2L1977.1,270.6"
    />
    <path
      fill="#393939"
      d="M848.2,614.1c15-19.3,25.7-44.9,22.5-70.6c-22.5,1-49.2,15-65.2,33.1c-13.9,16.1-26.7,42.8-23.5,67.4
      C807.6,647.3,832.1,633.4,848.2,614.1 M870.6,650.5c-36.3-2.2-67.4,20.3-84.5,20.3s-43.9-19.3-72.8-19.3
      c-37.5,1-71.7,21.4-90.9,55.6c-38.5,67.4-10.6,166.9,27.9,221.5c18.2,26.7,40.7,56.7,69.6,55.6c27.9-1,38.5-18.2,71.7-18.2
      c33.1,0,42.8,18.2,72.8,17.1s49.2-26.7,67.4-54.6c21.4-31.1,29.9-61,29.9-62c-1-1-58.8-22.5-58.8-88.8c-1-55.6,44.9-82.4,47.1-83.5
      C925.2,655.9,884.6,651.5,870.6,650.5"
    />
    <g>
      <path
        fill="#393939"
        d="M1185.2,574.5c79.2,0,133.8,54.6,133.8,132.7c0,79.2-55.6,133.8-135.9,133.8h-86.7v138h-63.2V574.5H1185.2z M1096.5,788.5
        h71.7c54.6,0,85.6-29.9,85.6-80.3c0-51.4-31.1-80.3-85.6-80.3h-72.8v160.5L1096.5,788.5L1096.5,788.5z M1335.1,896.6
        c0-51.4,39.6-83.5,110.2-87.7l81.3-4.2v-22.5c0-33.1-22.5-52.4-58.8-52.4c-35.3,0-56.7,17.1-62,42.8h-57.9
        c3.2-53.5,49.2-93.1,122-93.1c71.7,0,117.7,37.5,117.7,97.3v203.3h-57.8v-48.2h-1c-17.1,33.1-54.6,53.5-93.1,53.5
        C1375.8,985.4,1335.1,949,1335.1,896.6L1335.1,896.6z M1526.6,869.8v-23.5l-72.8,4.2c-36.3,2.2-56.7,18.2-56.7,43.9
        s21.4,42.8,53.5,42.8C1493.4,937.2,1526.6,908.3,1526.6,869.8L1526.6,869.8z M1641.1,1089.2v-49.2c4.2,1,15,1,19.3,1
        c27.9,0,42.8-11.8,52.4-41.7c0-1,5.4-18.2,5.4-18.2l-107-295.3h65.2l74.9,240.8h1l74.9-240.8h64.2l-110.2,311.4
        c-25.7,71.7-54.6,94.1-115.6,94.1C1661.5,1090.3,1646.4,1090.3,1641.1,1089.2L1641.1,1089.2z"
      />
    </g>
  </svg>
)

export const Visa = ({ height }) => (
  <svg version="1.1" x="0px" y="0px" viewBox="0 0 750 471" height={height}>
    <g>
      <path
        id="Shape"
        fill="#393939"
        d="M278.2,334.2l33.4-195.8H365l-33.4,195.8H278.2L278.2,334.2z"
      />
      <path
        id="path13"
        fill="#393939"
        d="M524.3,142.7c-10.6-4-27.1-8.2-47.8-8.2c-52.7,0-89.9,26.6-90.2,64.6
        c-0.3,28.1,26.5,43.8,46.8,53.2c20.8,9.6,27.8,15.7,27.7,24.3c-0.1,13.1-16.6,19.1-31.9,19.1c-21.4,0-32.7-3-50.2-10.3l-6.9-3.1
        l-7.5,43.8c12.5,5.5,35.5,10.2,59.4,10.4c56.1,0,92.5-26.2,92.9-66.9c0.2-22.3-14-39.2-44.8-53.2c-18.6-9.1-30.1-15.1-30-24.3
        c0-8.1,9.7-16.8,30.6-16.8c17.4-0.3,30.1,3.5,39.9,7.5l4.8,2.3L524.3,142.7"
      />
      <path
        id="Path"
        fill="#393939"
        d="M661.6,138.5h-41.2c-12.8,0-22.3,3.5-27.9,16.2l-79.2,179.4h56
        c0,0,9.2-24.1,11.2-29.4c6.1,0,60.6,0.1,68.3,0.1c1.6,6.9,6.5,29.3,6.5,29.3h49.5L661.6,138.5L661.6,138.5z M596.2,264.9
        c4.4-11.3,21.3-54.7,21.3-54.7c-0.3,0.5,4.4-11.3,7.1-18.7l3.6,16.9c0,0,10.2,46.7,12.4,56.5H596.2L596.2,264.9L596.2,264.9z"
      />
      <path
        id="path16"
        fill="#393939"
        d="M45.9,138.5l-0.7,4.1c21.1,5.1,39.9,12.5,56.4,21.7L149,333.9l56.5-0.1l84-195.4H233L180.7,272
        l-5.6-27.1c-0.3-0.8-0.5-1.7-0.8-2.5L156.1,155c-3.2-12.4-12.6-16.1-24.2-16.5H45.9z"
      />
    </g>
  </svg>
)

export const Instagram = ({ height, color = 'black' }) => (
  <svg
    version="1.1"
    id="Logo"
    x="0px"
    y="0px"
    viewBox="0 0 512 512"
    height={height}
  >
    <g fill={color}>
      <path
        d="M256,49.5c67.3,0,75.2,0.3,101.8,1.5c24.6,1.1,37.9,5.2,46.8,8.7c11.8,4.6,20.2,10,29,18.8c8.8,8.8,14.3,17.2,18.8,29
				c3.4,8.9,7.6,22.2,8.7,46.8c1.2,26.6,1.5,34.5,1.5,101.8s-0.3,75.2-1.5,101.8c-1.1,24.6-5.2,37.9-8.7,46.8
				c-4.6,11.8-10,20.2-18.8,29c-8.8,8.8-17.2,14.3-29,18.8c-8.9,3.4-22.2,7.6-46.8,8.7c-26.6,1.2-34.5,1.5-101.8,1.5
				s-75.2-0.3-101.8-1.5c-24.6-1.1-37.9-5.2-46.8-8.7c-11.8-4.6-20.2-10-29-18.8c-8.8-8.8-14.3-17.2-18.8-29
				c-3.4-8.9-7.6-22.2-8.7-46.8c-1.2-26.6-1.5-34.5-1.5-101.8s0.3-75.2,1.5-101.8c1.1-24.6,5.2-37.9,8.7-46.8
				c4.6-11.8,10-20.2,18.8-29c8.8-8.8,17.2-14.3,29-18.8c8.9-3.4,22.2-7.6,46.8-8.7C180.8,49.7,188.7,49.5,256,49.5 M256,4.1
				c-68.4,0-77,0.3-103.9,1.5C125.3,6.8,107,11.1,91,17.3c-16.6,6.4-30.6,15.1-44.6,29.1c-14,14-22.6,28.1-29.1,44.6
				c-6.2,16-10.5,34.3-11.7,61.2C4.4,179,4.1,187.6,4.1,256c0,68.4,0.3,77,1.5,103.9c1.2,26.8,5.5,45.1,11.7,61.2
				c6.4,16.6,15.1,30.6,29.1,44.6c14,14,28.1,22.6,44.6,29.1c16,6.2,34.3,10.5,61.2,11.7c26.9,1.2,35.4,1.5,103.9,1.5
				s77-0.3,103.9-1.5c26.8-1.2,45.1-5.5,61.2-11.7c16.6-6.4,30.6-15.1,44.6-29.1c14-14,22.6-28.1,29.1-44.6
				c6.2-16,10.5-34.3,11.7-61.2c1.2-26.9,1.5-35.4,1.5-103.9s-0.3-77-1.5-103.9c-1.2-26.8-5.5-45.1-11.7-61.2
				c-6.4-16.6-15.1-30.6-29.1-44.6c-14-14-28.1-22.6-44.6-29.1c-16-6.2-34.3-10.5-61.2-11.7C333,4.4,324.4,4.1,256,4.1L256,4.1z"
      />
      <path
        d="M256,126.6c-71.4,0-129.4,57.9-129.4,129.4S184.6,385.4,256,385.4S385.4,327.4,385.4,256S327.4,126.6,256,126.6z M256,340
				c-46.4,0-84-37.6-84-84s37.6-84,84-84c46.4,0,84,37.6,84,84S302.4,340,256,340z"
      />
      <circle cx="390.5" cy="121.5" r="30.2" />
    </g>
  </svg>
)

export const Facebook = ({ height, color = 'black' }) => (
  <svg x="0px" y="0px" viewBox="0 0 35.4 35.4" height={height}>
    <path
      fill={color}
      d="M20.5,35.4V19.3h5.4l0.8-6.3h-6.2v-4c0-1.8,0.5-3.1,3.1-3.1l3.3,0V0.2C26.3,0.2,24.4,0,22.1,0
	C17.2,0,14,2.9,14,8.3V13H8.5v6.3H14v16.2L20.5,35.4L20.5,35.4z"
    />
  </svg>
)

export const Pinterest = ({ height, color = 'black' }) => (
  <svg x="0px" y="0px" viewBox="0 0 35.4 35.4" height={height}>
    <path
      fill={color}
      d="M4,12.7c0-1.5,0.3-3,0.9-4.4s1.5-2.8,2.7-4.1s2.7-2.3,4.6-3s4-1.2,6.3-1.2c3.7,0,6.8,1.2,9.2,3.5s3.6,5,3.6,8.2
	c0,4-1,7.4-3.1,10s-4.7,3.9-7.9,3.9c-1.1,0-2.1-0.2-3-0.7c-0.9-0.5-1.6-1.1-2-1.8l-1.4,5.6c-0.1,0.4-0.3,0.9-0.5,1.4
	c-0.2,0.5-0.4,0.9-0.6,1.3c-0.2,0.4-0.4,0.8-0.7,1.2s-0.4,0.7-0.7,1.1c-0.2,0.3-0.4,0.6-0.6,0.8c-0.2,0.2-0.3,0.4-0.5,0.6l-0.2,0.3
	c-0.1,0.1-0.2,0.1-0.3,0.1c-0.1,0-0.2-0.1-0.2-0.2c0,0,0-0.2-0.1-0.5c0-0.3-0.1-0.6-0.1-1c0-0.3-0.1-0.8-0.1-1.3c0-0.5,0-1.1,0-1.6
	c0-0.5,0-1.1,0.1-1.7c0.1-0.6,0.1-1.2,0.3-1.7c0.3-1.1,1.1-4.8,2.6-11.1c-0.2-0.4-0.3-0.8-0.5-1.4C12,14.5,12,14,12,13.7l0-0.5
	c0-1.5,0.4-2.8,1.1-3.8s1.7-1.5,2.8-1.5c0.9,0,1.5,0.3,2,0.9s0.7,1.3,0.7,2.2c0,0.5-0.1,1.2-0.3,2c-0.2,0.8-0.5,1.7-0.8,2.7
	s-0.6,1.9-0.7,2.5c-0.2,1.1,0,2,0.6,2.8s1.5,1.2,2.6,1.2c1.9,0,3.4-1.1,4.6-3.2c1.2-2.1,1.8-4.7,1.8-7.7c0-2.3-0.7-4.2-2.2-5.6
	S20.7,3.5,18,3.5c-3,0-5.4,1-7.2,2.9S8,10.6,8,13.2c0,1.6,0.4,2.9,1.3,4c0.3,0.4,0.4,0.7,0.3,1.1c0,0.1-0.1,0.4-0.2,0.8
	c-0.1,0.4-0.2,0.7-0.2,0.8c0,0.3-0.2,0.4-0.4,0.5c-0.2,0.1-0.4,0.1-0.6,0c-1.4-0.6-2.4-1.5-3.1-2.9C4.4,16.2,4,14.6,4,12.7z"
    />
  </svg>
)

export const LinkedIn = ({ height, color = 'black' }) => (
  <svg height={height} viewBox="0 0 256 256">
    <g fill="none">
      <path
        d="M0 18.338C0 8.216 8.474 0 18.92 0h218.16C247.53 0 256 8.216 256 18.338v219.327C256 247.79 247.53 256 237.08 256H18.92C8.475 256 0 247.791 0 237.668V18.335z"
        fill={color}
      />
      <path
        d="M77.796 214.238V98.986H39.488v115.252H77.8zM58.65 83.253c13.356 0 21.671-8.85 21.671-19.91-.25-11.312-8.315-19.915-21.417-19.915-13.111 0-21.674 8.603-21.674 19.914 0 11.06 8.312 19.91 21.169 19.91h.248zM99 214.238h38.305v-64.355c0-3.44.25-6.889 1.262-9.346 2.768-6.885 9.071-14.012 19.656-14.012 13.858 0 19.405 10.568 19.405 26.063v61.65h38.304v-66.082c0-35.399-18.896-51.872-44.099-51.872-20.663 0-29.738 11.549-34.78 19.415h.255V98.99H99.002c.5 10.812-.003 115.252-.003 115.252z"
        fill="#000"
      />
    </g>
  </svg>
)
